:host {
  display: block;

  *, ::after, ::before {
    box-sizing: border-box;
  }

  [slot="icon-before"],
  [slot="icon-after"] {
    display: none;
  }
}
